<template>
    <div class="contract-data" v-if="currentComponent">
        <h3 class="font-weight-bold">
            {{ $t('contrato_rastreabilidade.messages.contract_data.title') }}
        </h3>
        <el-card>
            <component
                v-model="form.contract_data"
                :is="currentComponent"
                ref="contractDataComponent"
            />
        </el-card>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'ContractData',
    data() {
        return {
            components: {
                'PY': () =>
                    import(
                        '@/modules/traceability-contract/views/components/contract-data/py.vue'
                    )
            }
        };
    },
    computed: {
        ...mapState('traceabilityContractModule', ['form']),
        currentComponent() {
            this.$emit('input', {});
            const user = this.$store.state.usuarioLogado;
            return this.components[user.paisGrupo];
        }
    }
};
</script>

<style scoped lang="scss">
h3 {
    margin: 16px 0;
    color: #3B3B3B;
    font-weight: 500;
    font-size: 16px;
}
</style>
